module.exports = __webpack_public_path__ + "static/media/jumping-woman.c1858f7a.svg";